import { render, staticRenderFns } from "./itsHome.vue?vue&type=template&id=15146ea8&"
import script from "./itsHome.vue?vue&type=script&lang=js&"
export * from "./itsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports